import { TIER } from '@nx/state';

// 13 seconds because if value is too low we could hit the rate limit of app-ingress (API Gateway)
export const POLLING_INTERVAL_DATA_APIS = 13000;

// Allowed Aura instance tiers for running a Data API
export const ALLOWED_INSTANCE_TIERS = [TIER.PROFESSIONAL, TIER.MTE];
